<div class="card details my-3">
  <div class="card-header" *ngIf="!isWebView">
    <a [routerLink]="['/tasks']" class="back-link mb-0">
      <i class="fa fa-chevron-left"></i> Care Plan
    </a>
  </div>
  <ng-container *ngIf="(task$ | async) as task">
    <div class="card-body px-5">
      <div class="task-header">
        <h2 class="mt-0 font-weight-light">{{ task.phiVisibleTitle }}</h2>
        <h3 *ngIf="task.subtitle" class="mt-0">{{ task.subtitle }}</h3>

        <div class="profile-bubble-container pull-left pt-1 pr-3 pb-sm-2">
          <om-profile-bubble
            [profile]="task.provider"
            [colorCombo]="task.provider.id"
            size="medium"
          ></om-profile-bubble>
        </div>
        <p class="mb-0 font-weight-light">{{ task.orderedByString }}</p>
        <p class="mb-0 font-weight-bold">{{ task.scheduledAtString }}</p>
        <hr />
      </div>

      <div class="section completed-on mb-3 mb-md-4" *ngIf="task.isCompleted">
        <div class="icon"></div>
        <h5 class="font-weight-bold ml-3 ml-md-5">
          Completed {{ task.completedOn | moment: "MMMM YYYY" }}
        </h5>
      </div>

      <div class="section declined-on mb-3 mb-md-4" *ngIf="task.isDeclined">
        <div class="icon"></div>
        <h5 class="font-weight-bold ml-3 ml-md-5">
          Declined {{ task.declinedOn | moment: "MMMM YYYY" }}
        </h5>
      </div>

      <ng-container [ngSwitch]="task.type" *ngIf="task.isAssigned">
        <om-lab-order-details *ngSwitchCase="'lab_order'" [task]="task"></om-lab-order-details>
        <om-vaccine-order-details
          *ngSwitchCase="'vaccine_order'"
          [task]="task"
        ></om-vaccine-order-details>
        <om-basic-follow-up-order-details
          *ngSwitchCase="'basic_follow_up_order'"
          [task]="task"
          (completed)="completeTask($event)"
        ></om-basic-follow-up-order-details>
        <om-generic-follow-up-order-details
          *ngSwitchCase="'generic_follow_up_order'"
          [task]="task"
          (completed)="completeTask($event)"
        ></om-generic-follow-up-order-details>
        <om-visit-follow-up-order-details
          *ngSwitchCase="'visit_follow_up_order'"
          [task]="task"
        ></om-visit-follow-up-order-details>
        <om-survey-order-details
          *ngSwitchCase="'survey_order'"
          [task]="task"
        ></om-survey-order-details>
        <om-consult-order-details
          *ngSwitchCase="'consult_order'"
          [task]="task"
        ></om-consult-order-details>
      </ng-container>
      <om-task-options
        *ngIf="task.isAssigned"
        [task]="task"
        (completed)="showCompleteModal()"
        (declined)="showDeclineModal()"
        (secondButtonCompleted)="secondButtonCompleted()"
      ></om-task-options>
    </div>
  </ng-container>

  <ng-container *ngIf="(task$ | async) as task">
    <ng-template #declineModal let-dismiss="dismiss">
      <div class="modal-header">
        <h5 class="modal-title">
          Are you sure you want to decline this
          {{ task.type == "vaccine_order" ? "vaccine" : "Action Item" }}?
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="task.type == 'vaccine_order'">
        If you decline this vaccine, the order for this vaccine on your chart will be closed.
      </div>
      <div class="modal-body" *ngIf="task.type !== 'vaccine_order'">
        If you decline this Action Item, it will be removed from your Care Plan.
      </div>
      <div class="modal-footer">
        <button (click)="dismiss()" class="btn btn-alternate">Cancel</button>
        <button (click)="declineTask()" class="btn btn-primary">Decline</button>
      </div>
    </ng-template>

    <ng-template #wentElsewhereModal let-dismiss="dismiss">
      <om-consult-order-elsewhere-completion (close)="dismiss()" (completed)="completeTask($event)">
      </om-consult-order-elsewhere-completion>
    </ng-template>

    <ng-container [ngSwitch]="task.type">
      <om-vaccine-order-completion
        *ngSwitchCase="'vaccine_order'"
        #completeModal
        (completed)="completeTask($event)"
      ></om-vaccine-order-completion>
      <om-visit-follow-up-order-completion
        *ngSwitchCase="'visit_follow_up_order'"
        #completeModal
        (completed)="completeTask($event)"
      ></om-visit-follow-up-order-completion>
    </ng-container>
  </ng-container>
</div>
